export default __webpack_public_path__ + "static/media/modern-large.ce8dd4fc.jpg";